// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G7C9","index":"styles_index__397Rm"};